import { ReactNode } from 'react';

interface StatCardProps {
    icon: ReactNode;
    label: string;
    value: string | number;
    subtext?: string;
    className?: string;
}

export default function StatCard({ icon, label, value, subtext, className = '' }: StatCardProps) {
    const isEmoji = typeof icon === 'string' && icon.length <= 4;

    return (
        <div className={`card overflow-hidden group ${className}`}>
            <div className="flex items-start gap-4">
                <div className={`shrink-0 ${isEmoji ? 'text-3xl' : 'p-2.5 bg-dark- surface border border-dark-border rounded-2xl group-hover:border-accent-purple/30 transition-colors'}`}>
                    {icon}
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-[10px] font-bold text-dark-muted uppercase tracking-widest mb-1 truncate">{label}</p>
                    <p className="text-2xl font-black tracking-tight truncate">{value}</p>
                    {subtext && <p className="text-xs font-medium text-dark-muted mt-1 truncate">{subtext}</p>}
                </div>
            </div>
        </div>
    );
}
